import { PrivilegeEnum as a } from "@hprofits/shared/auth";
import { z as r } from "zod";
import { ocPrivate as t } from "../common/auth/procedure-builders.js";
import "../common/errors/constants.js";
import { notFoundError as o, expectationFailedError as c } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as e } from "../swagger/tags.js";
import { UpdatePaymentInformationSchema as u, PaymentInformationSchema as i, PaymentInformationResponseSchema as s, BillingCountriesResponseSchema as p, AccountBalanceResponseSchema as l, AccountManagerResponseSchema as d, AccountPaymentIdParamSchema as n, CreateAccountPaymentSchema as h, CreateAccountPaymentResultSchema as y, AccountPaymentsQuerySchema as A, AccountPaymentsResponseSchema as f, UpdateAccountProfileSchema as g, AccountProfileSchema as m } from "./schemas.js";
const G = {
  account: {
    profile: t().route({
      method: "GET",
      path: "/account/profile",
      summary: "Get the caller profile",
      tags: [e.ACCOUNT.name]
    }).output(m).errors(o("Account not found")),
    updateProfile: t().route({
      method: "PATCH",
      path: "/account/profile",
      summary: "Update the caller personal settings",
      tags: [e.ACCOUNT.name]
    }).input(g).output(m).errors(o("Account not found")),
    /** Payment transactions of the caller, one page. */
    payments: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/account/payments",
      summary: "List the caller payment transactions",
      tags: [e.ACCOUNT.name]
    }).input(A).output(f).errors({}),
    createPayment: t([a.WriteAdvert]).route({
      method: "POST",
      path: "/account/payments",
      summary: "Create a payment of the caller waiting for approval",
      tags: [e.ACCOUNT.name],
      successStatus: 201
    }).input(h).output(y).errors({
      ...c("Billing details are missing or the amount is below the minimum")
    }),
    invoice: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/account/payments/{paymentId}/invoice",
      summary: "Download the invoice PDF of a caller payment",
      tags: [e.ACCOUNT.name]
    }).input(n).output(r.file()).errors({
      ...o("Payment not found, not the caller, or its invoice is not ready yet")
    }),
    deletePayment: t([a.WriteAdvert]).route({
      method: "DELETE",
      path: "/account/payments/{paymentId}",
      summary: "Delete a not yet approved payment of the caller",
      tags: [e.ACCOUNT.name],
      successStatus: 204
    }).input(n).output(r.void()).errors({
      ...o("Payment not found, not the caller, or already approved")
    }),
    /** Account manager assigned to the caller (`users.sales_owner`), or `null`. */
    manager: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/account/manager",
      summary: "Get the caller account manager",
      tags: [e.ACCOUNT.name]
    }).output(d).errors({}),
    /** Balance of the caller acting as an advertiser: payments minus ad spend; `null` for other roles. */
    balance: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/account/balance",
      summary: "Get the caller account balance",
      tags: [e.ACCOUNT.name]
    }).output(l).errors({}),
    billingCountries: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/account/billing-countries",
      summary: "List the billing countries",
      tags: [e.ACCOUNT.name]
    }).output(p).errors({}),
    paymentInformation: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/account/payment-information",
      summary: "Get the caller billing details",
      tags: [e.ACCOUNT.name]
    }).output(s).errors({}),
    updatePaymentInformation: t([a.WriteAdvert]).route({
      method: "PUT",
      path: "/account/payment-information",
      summary: "Save the caller billing details",
      tags: [e.ACCOUNT.name]
    }).input(u).output(i).errors({
      ...o("Billing country not found")
    })
  }
};
export {
  G as accountContract
};
//# sourceMappingURL=contract.js.map
